// Common types

export type TRCAOperation = 'CREATE' | 'UPDATE' | 'DELETE';

export type TRCAMode = 'MANDATORY_MANDATORY' | 'OPTIONAL_MANDATORY' | 'MANDATORY_OPTIONAL' | 'OPTIONAL_OPTIONAL';

export enum TRCACategory {
  MAN = 'MAN',
  MACHINE = 'MACHINE',
  MATERIAL = 'MATERIAL',
  METHOD = 'METHOD',
}

// --- /upload ---
export type TRCAUploadRequest = {
  factoryId: string;
  rcaFile: File;
};

export type TRCAUploadResponse = {
  success: boolean;
  message: string;
  errors: string[];
};

// --- /template ---
// No request body needed, returns file

// --- /mappings/:factoryId (GET) ---
export type TRCAMappingsResponse = {
  mappings: TRCAMapping[];
};

export type TRCAMapping = {
  id: number;
  name: string;
  correctiveActions: TCorrectiveAction[];
  preventiveActions: TPreventiveAction[];
};

export type TCorrectiveAction = {
  id: number;
  name: string;
};

export type TPreventiveAction = {
  id: number;
  name: string;
};

// --- /mappings/crud (POST) ---
export type TRCAMappingCrudRequest = {
  operation: TRCAOperation;
  rootCauseId?: number; // Optional for CREATE, required for UPDATE/DELETE
  rootCauseName: string;
  rootCauseCategory: TRCACategory;
  factoryId: string;
  correctiveActions: TCorrectiveActionInput[];
  preventiveActions: TPreventiveActionInput[];
};

export type TCorrectiveActionInput = {
  id?: number | null; // null for new actions, number for existing
  name: string;
};

export type TPreventiveActionInput = {
  id?: number | null; // null for new actions, number for existing
  name: string;
};

export type TRCAMappingCrudResponse = {
  success: boolean;
  message: string;
  errors: string[];
  updatedMapping?: {
    rootCauseId: number;
    rootCauseName: string;
    correctiveActions: TCorrectiveAction[];
    preventiveActions: TPreventiveAction[];
  };
};

// --- /config/:factoryId (GET/POST) ---
export type TRCAConfigRequest = {
  rcaMode: TRCAMode;
};

export type TRCAConfigResponse = {
  factoryId: string;
  rcaMode: TRCAMode;
};

// --- /validate/:factoryId (POST) ---
export type TRCAValidationRequest = {
  rootCauseIds: number[];
  correctiveActionIds: number[];
  preventiveActionIds: number[];
};

export type TRCAValidationResponse = {
  valid: boolean;
  errors: string[];
};

// --- /hierarchical/:factoryId (GET) ---
export type TRCAHierarchicalResponse = {
  categories: TRCAHierarchicalData[];
};

export type TRCAHierarchicalData = {
  category: TRCACategory;
  rootCauses: TRCAMapping[];
};

// --- /categories (GET) ---
export type TRCACategoriesResponse = {
  categories: TRCACategory[];
};

// --- /rootcauses/:factoryId/:category (GET) ---
export type TRCARootCausesByCategoryResponse = {
  factoryId: string;
  category: TRCACategory;
  rootCauses: TRootCauseItem[];
};

export type TRootCauseItem = {
  id: number;
  name: string;
  category: TRCACategory;
};

// --- /actions/:rootCauseId (GET) ---
export type TRCACorrectiveActionsByRootCauseResponse = {
  correctiveActions: TCorrectiveAction[];
};

// --- /preventiveactions/:rootCauseId (GET) ---
export type TRCAPreventiveActionsByRootCauseResponse = {
  preventiveActions: TPreventiveAction[];
};

// Error types
export type TRCAError = {
  code: string;
  message: string;
  field?: string;
};

// Select RCA component state type
export type TSelectedRCA = {
  rootCause: TRCAMapping | null;
  selectedCorrectiveActions: TCorrectiveAction[];
  selectedPreventiveActions: TPreventiveAction[];
};